import { Client } from '@connectrpc/connect';

import { SupportService } from './espb/support_service_pb';
import { ProfileId, ReportPageProblemKnownValue, SupportMessageTypeKnownValue } from './types';

export default class SupportServiceClient {
  constructor(private readonly espbClient: Client<typeof SupportService>) {}

  async sendMessage(
    type: SupportMessageTypeKnownValue,
    subject: string,
    message: string,
    profileId?: ProfileId,
    attachments?: {
      filename: string;
      data: Uint8Array;
      mimeType: string;
    }[],
  ): Promise<void> {
    await this.espbClient.sendMessage({ type, subject, message, profileId, attachments });
  }

  async reportPage(
    url: string | undefined,
    problem: ReportPageProblemKnownValue,
    comment: string,
    screenshot: string | undefined,
    hasLogin: boolean,
    hasHideSecretsLogin: boolean,
    hasShadowRoot: boolean,
    pageSource?: string,
    profileId?: ProfileId,
  ): Promise<void> {
    await this.espbClient.reportPage({
      url,
      problem,
      comment,
      screenshot,
      hasLogin,
      hasHideSecretsLogin,
      pageSource,
      hasShadowRoot,
      profileId,
    });
  }
}
